export const environment = {
  VERSION        : 2.2,
  API_ENDPOINT   : 'https://mapapp-pprd.apps.airliquide.com/api',
  API_KEY        : 'PAkfg6471E58enb5GS899TeVucz6biu9',
  RESET_PASS_URL : 'https://mapapp-pprd.apps.airliquide.com/portal/#/createpassword/{0}',
  GOOGLE_AUTH_ID : '203031426868-qhvaq9hlu19lsucjinh7roul0jmvgf8a.apps.googleusercontent.com',
}


// WEBPACK FOOTER //
// ./src/environments/environment.ts